import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_IIRGD_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { AtualizarCidadaoAutistaRequest, Types } from './types';

// ACTIONS
import {
	atualizarCidadaoAutistaSuccess,
	atualizarCidadaoAutistaFailure,
} from './actions';

function* atualizarCidadaoAutista(request: ReducerActionRotaSP) {
	const token: string = yield select(state => state.user.token.data);
	const { payload }: { payload: AtualizarCidadaoAutistaRequest } = request;

	const response: ApiResponse = yield call(
		putApi,
		token,
		PATH_IIRGD_API,
		`cidadao-autista`,
		payload.requestData,
		payload.header,
	);

	if (response.status === 200) {
		yield put(atualizarCidadaoAutistaSuccess(response));
	} else {
		yield put(atualizarCidadaoAutistaFailure(response));
	}
}

export default all([
	takeLatest(Types.ATUALIZAR_CIDADAO_AUTISTA_REQUEST, atualizarCidadaoAutista),
]);
